/**
 * Where the web host starts from, under the operator's delta. The library's
 * presets were tuned on a dark stage with the pack alone on it; here the pack
 * shares the stage with the winner chrome and sits on a light operator
 * background, so it takes more of the band it is given (a phone's band is
 * short), the card is a touch wider against it, and the glows around the
 * card are turned down. The knobs show these values as their defaults, so
 * "Reset to preset" lands here.
 */
export const WEB_BASE = {
  layout: {
    pack: { widthRatio: 0.9, heightRatio: 0.92, offsetY: 0 },
    card: { packWidthRatio: 0.7 },
    // The radial bloom behind the card: three card widths of white on a
    // light backdrop swallowed the stage
    glow: { bloomScaleX: 2, bloomScaleY: 1.6 },
  },
  theme: {
    // The spin drives the bloom to full brightness whatever `bloomAlpha`
    // says, so the light itself is dimmer: grey adds less than white
    bloom: '#8c8c9c',
    // The winner's DOM card rounds at up to 18 px and takes over from the
    // scene's card; 0.5's 6 px made that hand-off visibly squarer-to-rounder
    cornerRadius: 14,
    // The rarity word behind the card, in the slot lane's display face — the
    // iframe ships it, so the scene's word reads like the slot lane's
    badgeFont: '"Bebas Neue", "Reddit Sans Condensed", "Inter", sans-serif',
  },
  motion: {
    reveal: { bloomAlpha: 0.5, spinBloom: 0.35, rimAlpha: 0.6, haloAlpha: 0.75 },
  },
} as const;

/**
 * The carousel lays its ring out on its own terms — the front copy is a
 * fraction of the stage so the ring fits, and the card is sized against the
 * held pack, not a sealed one — so it keeps the library's pack and card
 * layout and takes only the glows and the bloom from the web base.
 */
export const WEB_BASE_CAROUSEL = {
  layout: { glow: WEB_BASE.layout.glow },
  theme: WEB_BASE.theme,
  motion: WEB_BASE.motion,
} as const;
